import React from 'react';
import { useSelector } from 'react-redux';

import { ContactBox } from 'ui';

import mockedPersonalAdvisor from 'assets/mockedData/personalAdvisor.json';
import { contactTypes, contactTargets } from 'shared/constants/contactBox';
import { useContact } from 'shared/hooks';

export const HomeContactBox = () => {
  const {
    data: { organisation },
  } = useSelector(state => state.auth);
  const contact = useContact();

  const internal = organisation.scopeOrganisationType === 'INTERNAL';

  const data = internal
    ? {
        firstName: mockedPersonalAdvisor.personalAdvisor.firstName,
        lastName: mockedPersonalAdvisor.personalAdvisor.lastName,
        jobTitle: mockedPersonalAdvisor.personalAdvisor.jobTitle,
      }
    : {
        firstName: organisation.personalAdvisor.firstName,
        lastName: organisation.personalAdvisor.name,
        jobTitle: organisation.personalAdvisor.jobTitle,
        userId: organisation.personalAdvisor.userId,
      };

  data.jobFunction = mockedPersonalAdvisor.jobFunction;
  data.internal = internal;

  const handleContact = (type, target) => async ({ subject, message, origin }) => {
    contact({ type, subject, message, origin, target });
  };

  return (
    <ContactBox
      {...data}
      empty={!organisation}
      showMessageButton={!internal}
      showRequestCallButton={!internal}
      onRequestCall={handleContact(contactTypes.CALL, contactTargets.PERSONAL_ADVISER)}
      onSendMessage={handleContact(contactTypes.MESSAGE, contactTargets.PERSONAL_ADVISER)}
    />
  );
};
